<div
  [class]="containerClass$ | async"
  aria-hidden="true"
  *ngIf="shape$ | async as dir"
>
  <ng-container *ngIf="dir === 'triangle'; else circle">
    <svg
      [style]="iconStyle"
      [class]="svgClass$ | async"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g id="exclamation-triangle">
        <g id="_Path_" data-name="&lt;Path&gt;">
          <path
            d="M20,18.75H4a.76.76,0,0,1-.65-.37.77.77,0,0,1,0-.75l8-14a.78.78,0,0,1,1.3,0l8,14a.77.77,0,0,1,0,.75A.76.76,0,0,1,20,18.75ZM5.29,17.25H18.71L12,5.51Z"
          />
        </g>
        <path
          d="M12,13.25a.76.76,0,0,1-.75-.75V9a.75.75,0,0,1,1.5,0v3.5A.76.76,0,0,1,12,13.25Z"
        />
        <path
          d="M12,16.25a.76.76,0,0,1-.75-.75V15a.75.75,0,0,1,1.5,0v.5A.76.76,0,0,1,12,16.25Z"
        />
      </g>
    </svg>
  </ng-container>
</div>

<ng-template #circle>
  <svg
    [style]="iconStyle"
    [class]="svgClass$ | async"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="exclemation-circle">
      <path
        d="M12,21a9,9,0,1,1,9-9A9,9,0,0,1,12,21ZM12,4.5A7.5,7.5,0,1,0,19.5,12,7.5,7.5,0,0,0,12,4.5Z"
      />
      <path
        d="M12,13a.76.76,0,0,1-.75-.75V8.75a.75.75,0,0,1,1.5,0v3.5A.76.76,0,0,1,12,13Z"
      />
      <path
        d="M12,16a.76.76,0,0,1-.75-.75v-.5a.75.75,0,0,1,1.5,0v.5A.76.76,0,0,1,12,16Z"
      />
    </g>
  </svg>
</ng-template>
